/* global roomvo */
import React, { useEffect } from 'react';
import { ExperienceContext, useConfigService } from '@thd-nucleus/experience-context';

export const RoomVoInspire = () => {
  const ROOMVO_SCRIPT_SRC = 'https://cdn.roomvo.com/static/scripts/b2b/homedepot.js';
  const { isConsumerApp } = React.useContext(ExperienceContext);
  const fsEnableRoomVoInspire = useConfigService('fs:enableRoomVoInspire');

  const handleClick = () => {
    roomvo.startStandaloneVisualizer({ extraParams: '&has_room_style_transfer_list=1' });
  };

  useEffect(() => {
    let loadedRoomVoScript = {};
    if (fsEnableRoomVoInspire) {
      let scripts = [];
      if (typeof window !== 'undefined' && window.document) {
        scripts = Array.from(document.getElementsByTagName('script'));
      }
      loadedRoomVoScript = scripts.find((script) => script.getAttribute('src') === ROOMVO_SCRIPT_SRC);

      if (!loadedRoomVoScript) {
        const script = document.createElement('script');
        script.src = ROOMVO_SCRIPT_SRC;
        script.type = 'text/javascript';
        script.async = true;
        document.body.appendChild(script);
      }
    }
    return () => {
      if (loadedRoomVoScript?.parentNode) {
        loadedRoomVoScript.parentNode.removeChild(loadedRoomVoScript);
      }
    };
  }, [fsEnableRoomVoInspire]);

  if (!fsEnableRoomVoInspire) {
    return null;
  }

  return (
    <button
      type="button"
      data-component="roomVoInspire"
      onClick={handleClick}
    >
      <picture>
        <source
          // eslint-disable-next-line max-len
          srcSet="https://dam.thdstatic.com/content/production/kOk4LJZZtS2LFwE8r2s3Iw/Co6K8M0SkG-M3UruzWKFtA/downloadImageForWeb/D59H-RoomvoInspireBanner-DESK.Jpg"
          media="(min-width: 768px)"
          alt="RoomVoInspire Desktop"
        />
        {/* eslint-disable-next-line @mizdra/layout-shift/require-size-attributes */}
        <img
          // eslint-disable-next-line max-len
          src="https://dam.thdstatic.com/content/production/YqQ2ij3GjzlqfBj9xSCbfQ/CxuQEw1c0IKZCjO6VZO2TA/downloadImageForWeb/D59H-RoomvoInspireBanner-MW.Jpg"
          alt="RoomVoInspire Mobile"
        />
      </picture>
    </button>
  );
};
RoomVoInspire.displayName = 'RoomVoInspire';
